export default __webpack_public_path__ + "static/Student Behaviour Management Policy-2b24d75b74e3ec6bc8a459f5b89c447b.pdf";